const whatsapp = 'https://d3t7cnf9sa42u5.cloudfront.net/websiteAssets/FooterAssets/whatsapp.svg';

export { whatsapp };
